<template>
  <div class="p-sms-item">
    <v-list class="p-sms-item__list">
      <template v-for="item in smsItem">
        <v-list-item v-bind:key="item.id">
          <v-row>
            <v-col>
              <v-row justify="center">
                <div class="p-sms-item__date">
                  {{ getDate(item.createdAt) }}
                </div>
              </v-row>
              <v-row :class="[item.outgoing ? 'justify-end' : 'justify-start']">
                <div :class="[item.outgoing ? 'p-sms-item__card--right' : 'p-sms-item__card--right']"
                     class="p-sms-item__card">
                  <div class="from mb-2 mr-3">
                    {{ item.message }}
                  </div>
                  <v-row justify="end" align="baseline" class="p-sms-item__card-time">
                    {{ getTime(item.createdAt) }}
                    <v-icon
                      v-if="item.delivered == null || !item.delivered"
                      class="p-sms-item__message-icon"
                      >
                      mdi-check
                    </v-icon>
                    <v-icon
                      v-if="item.delivered != null && item.delivered"
                      class="p-sms-item__message-icon p-sms-item__message-icon--color"
                      >
                      mdi-check-all
                    </v-icon>
                    <p-btn-icon v-if="hasAccess()"
                                type="delete"
                                @click="$emit('delete-event', item)">
                    </p-btn-icon>
                    <template v-if="!item.outgoing">
                      <v-tooltip
                        v-if="item.isRead"
                        bottom
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="p-sms-item__message-icon p-sms-item__message-icon--color"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-comment-check
                          </v-icon>
                        </template>
                        <span>{{ $t('sms.isReadHint') }}</span>
                      </v-tooltip>
                      <v-tooltip
                        v-else
                        bottom
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="p-sms-item__message-icon p-sms-item__message-icon--color"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-comment-outline
                          </v-icon>
                        </template>
                        <span>{{ $t('sms.isNotReadHint') }}</span>
                      </v-tooltip>
                    </template>
                  </v-row>
                  <v-row>
                    <v-switch
                      v-if="!item.outgoing && !item.isRead"
                      v-model="item.isRead"
                      :label="$t('sms.setSmsIsRead')"
                      inset
                      dense
                      class="p-input-switch"
                      @click.stop
                      @change="onIsReadChange(item)"
                    ></v-switch>
                  </v-row>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-list-item>
      </template>
    </v-list>
    <v-text-field
      v-model="message"
      v-if="hasAccess() && smsItem != null"
      :disabled="!smsLoaded"
      label="Type a message"
      class="p-sms-item__message"
      solo
      clearable
      v-on:keyup.enter="send"
    ></v-text-field>
  </div>
</template>


<script>
import { mapActions } from 'vuex'

import moment from 'moment'

import snackbarMixin from '@/mixins/snackbar.mixin'
import accessMixin from '@/mixins/access.mixin'

import PBtnIcon from '@/components/PBtnIcon'


export default {
  components: {
    PBtnIcon
  },


  mixins: [
    snackbarMixin,
    accessMixin
  ],


  props: {
    smsItem: Array,
    thread: String
  },


  data () {
    return {
      timeFormat: 'HH:mm',
      displayDate: 'MMM D',
      message: '',
      smsLoaded: true
    }
  },


  methods: {
    ...mapActions('sms', ['reSendSms', 'pushSms', 'popSms', 'putSmsRead']),

    async onIsReadChange (item) {
      await this.putSmsRead(item)
      this.$emit('isReadChanged')
    },

    getTime (smsDate) {
      if (smsDate === undefined) {
        return null
      }
      return moment(smsDate).format(this.timeFormat)
    },

    getDate (smsDate) {
      var currentDate = smsDate === undefined ? null : moment(smsDate).format(this.displayDate)
      if (currentDate === null || currentDate === this.messageDate) {
        return ''
      }
      this.messageDate = currentDate
      return currentDate
    },

    async send () {
      this.smsLoaded = false
      const sms = {
        threadId: this.thread,
        message: this.message
      }
      await this.pushSms(sms)
      try {
        await this.reSendSms(sms)
        this.message = null
      } catch (error) {
        await this.popSms()
        this.showSnackbarError()
        this.$log.error(error)
      }
      this.smsLoaded = true
    }
  },


  async updated () {
    this.messageDate = ''
  }
}
</script>
